import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import WeaveInputs from '../../components/WeaveInputs/WeaveInputs';
import { connect } from 'react-redux';
import { createWeaveRequestAction } from '../../store/weave/weaveActions';
import { useTranslation } from '../../hooks/useTranslation';
const CreateWeave = ({ createWeaveRequest, isLoading, createWeaveData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSubmit = (data) => {
    createWeaveRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/weave');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/weave" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
        {t('weave')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createWeave')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createWeave')}</h4></CCardHeader>
            <CCardBody>
              <WeaveInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createWeaveData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createWeaveData: state.weaveReducer.createWeaveData,
});

const mapDispatchToProps = (dispatch) => ({
  createWeaveRequest: (payload) => dispatch(createWeaveRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateWeave);
